import * as React from 'react';

const useDocumentTitle = (title: string | undefined) => {
  React.useEffect(() => {
    document.title = title ? `AMP | ${title}` : 'AMP';
  }, [title]);
};

export default useDocumentTitle;
